export default __webpack_public_path__ + "31c733067e44f23b0151d3cb22e6806a.png";